export   const ALL_AIRPORTS = [
    // Kerala & Neighboring
    { name: "Kozhikode", code: "CCJ" },
    { name: "Kochi", code: "COK" },
    { name: "Thiruvananthapuram", code: "TRV" },
    { name: "Kannur", code: "CNN" },
    { name: "Mangalore", code: "IXE" },
    { name: "Bengaluru", code: "BLR" },
    { name: "Chennai", code: "MAA" },
    { name: "Coimbatore", code: "CJB" },
    { name: "Madurai", code: "IXM" },

    // Major Indian cities
    { name: "Mumbai", code: "BOM" },
    { name: "Delhi", code: "DEL" },
    { name: "Hyderabad", code: "HYD" },
    { name: "Pune", code: "PNQ" },
    { name: "Ahmedabad", code: "AMD" },
    { name: "Jaipur", code: "JAI" },
    { name: "Kolkata", code: "CCU" },
    { name: "Goa", code: "GOI" },
    { name: "Nagpur", code: "NAG" },

    // Middle East (Gulf countries - popular work/tourism routes)
    { name: "Dubai", code: "DXB" },
    { name: "Abu Dhabi", code: "AUH" },
    { name: "Sharjah", code: "SHJ" },
    { name: "Doha", code: "DOH" },
    { name: "Muscat", code: "MCT" },
    { name: "Dammam", code: "DMM" },
    { name: "Riyadh", code: "RUH" },
    { name: "Jeddah", code: "JED" },
    { name: "Kuwait", code: "KWI" },
    { name: "Bahrain", code: "BAH" },

    // Southeast Asia (Popular with Malayalees)
    { name: "Singapore", code: "SIN" },
    { name: "Kuala Lumpur", code: "KUL" },
    { name: "Bangkok", code: "BKK" },
    { name: "Colombo", code: "CMB" },
    { name: "Malé", code: "MLE" },

    // Popular destinations in Europe
    { name: "London Heathrow", code: "LHR" },
    { name: "Frankfurt", code: "FRA" },
    { name: "Paris", code: "CDG" },
    { name: "Zurich", code: "ZRH" },

    // North America (NRI or long-haul)
    { name: "New York", code: "JFK" },
    { name: "Toronto", code: "YYZ" },
    { name: "Chicago", code: "ORD" },
    { name: "San Francisco", code: "SFO" },
    { name: "Washington DC", code: "IAD" },
    { name: "Dallas", code: "DFW" },

    // Australia/Gulf crossover
    { name: "Sydney", code: "SYD" },
    { name: "Melbourne", code: "MEL" },
    { name: "Perth", code: "PER" }
  ];